import { ITableService } from 'src/app/common/interfaces/table/table-service.interface';
import { IRtpNetActivityStatus } from '../../interfaces/account-activity/net-activity-status';

export abstract class AbstractRtpAccountActivityRespondentService extends ITableService {
  abstract getCurrentActivity(): Promise<string | undefined>;
}
